import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/membershipLengthSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const SalesPackageFilter = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector(
    (state) => state.membershipLengthByAgreement.isPricingOptionsLoading
  );

  const options = useSelector((state) => state.membershipLengthByAgreement.filters.pricing_options);
  const selectedOption = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.pricing_options
  );

  return (
    <div className="select-box" style={{ width: "145px" }}>
      <p>Sales Package</p>
      {isLoading ? (
        <LoadingAnimation uiLoader />
      ) : (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedOption}
          includeFilter
          enableOnly
          height={324}
          includeSelectAll
          numberDisplayed={0}
          onSelectChange={(data) => dispatch(actionCreators.updatePricingOptions(data))}
        />
      )}
    </div>
  );
};

export default SalesPackageFilter;
